import React from 'react';

import {optionHeadObj, nodeObj} from './dataObj.js';
import {optionOnClickHandler, resultFn} from './applicationFn.js';

export function optionRenderFn (selectThis) {
  let content = [];
  let props_optionList = new nodeObj(selectThis.env, 'select-optionList').props;
  let props_scrollFlat = new nodeObj(selectThis.env, 'scrollFlat').props;
  content.push(
    <div {...props_optionList}>
      {optionHeadRenderFn(selectThis)}
      <div {...props_scrollFlat}>
        {optionBodyRenderFn(selectThis)}
      </div>
    </div>
  );
  return content;
}

function optionHeadRenderFn (selectThis) {
  let content = [];
  if (selectThis.env.optionHeadVisible)
  {
    let props_listHead = new nodeObj(selectThis.env, 'optionList-head').props;
    let props_listHeadRow = new nodeObj(selectThis.env, 'head-row').props;
    content.push(
      <div {...props_listHead}>
        <div {...props_listHeadRow}>
          {
            selectThis.env.optionHeadArr.map((head_entry) => {
              let entry_row = new optionHeadObj(head_entry);
              let content_head_cell = [];
              let props_listHeadCell = new nodeObj(selectThis.env, 'row-cell').props;
              let cellName = `cell-${entry_row.index}`;
              props_listHeadCell.className += ` ${cellName}`;
              content_head_cell.push(
                <div {...props_listHeadCell}>
                  {entry_row.name}
                </div>
              );
              return content_head_cell;
            })
          }
        </div>
      </div>
    );
  }
  return content;
}
function optionBodyRenderFn (selectThis) {
  let content = [];
  let headArr = selectThis.env.optionHeadArr;
  let dataArr = resultFn(selectThis.searchStatusArr, selectThis.env.optionBodyArr);
  let props_listBody = new nodeObj(selectThis.env, 'optionList-body').props;
  content.push(
    <div {...props_listBody}>
      {
        (() => {
          let content_options = [];
          dataArr.map((body_entry, bodyIndex) => {
            let props_listBodyRow = new nodeObj(selectThis.env, 'body-row').props;
            let rowName = `row-${bodyIndex}`;
            props_listBodyRow.className += ` ${rowName}`;
            content_options.push(
              <div 
                {...props_listBodyRow}
                onClick={() => {_optionOnClickHandler(body_entry);}}
              >
                {
                  headArr.map((head_entry) => {
                    let entry_row = new optionHeadObj(head_entry);
                    let content_optionContent = [];
                    let props_listBodyCell = new nodeObj(selectThis.env, 'row-cell').props;
                    let cellName = `cell-${entry_row.index}`;
                    props_listBodyCell.className += ` ${cellName}`;
                    content_optionContent.push(
                      <div {...props_listBodyCell}>
                        {body_entry[entry_row.index]}
                      </div>
                    );
                    return content_optionContent;
                  })
                }
              </div>
            );
          });
          return content_options;
        })()
      }
      {
        (() => {
          let content_noData = [];
          if (0 == dataArr.length)
          {
            let props_tr = new nodeObj(selectThis.env, 'row-noData').props;
            let props_td = new nodeObj(selectThis.env, 'cell-noData').props;
            content_noData.push(
              <div 
                {...props_tr} 
                onClick={() => {_optionOnClickHandler({});}}
              >
                <div {...props_td}>
                  {selectThis.env.noDataMessage}
                </div>
              </div>
            );
          }
          return content_noData;
        })()
      }
    </div>
  );
  return content;

  function _optionOnClickHandler (optionObj) {
    optionOnClickHandler(selectThis, optionObj);
  }
}

